//import logo from './logo.svg';
import logo from './GateFlow.png';

export const settings = {
    "title": "GateFlow",
    "apiUrl": "https://csp-test.yec-playground.it/api",
    "ckdPath": "https://csp-test.yec-playground.it/",
    //"apiUrl": "https://csp-v2.gruppoyec.it/api",
    //"ckdPath": "https://csp-v2.gruppoyec.it/",
    "tinyKey": "u2y9r6cw0e1erg33drzg4fs0swwi1zrs85bcin3ynrsxlwz2",
    "config": {
        "limit": 100,
        "sortingField": 'id',
        "sortingOrder": 'desc'
    },
    "configEntity": {
        "gyv_voyage_double": {
            "limit": 50,
            "sortingField": 'riferimento_merce',
            "sortingOrder": 'asc'
        }
    },
    "theme": {
        "siderbarIconColor": 'rgba(233,236,239,.5)'
    },
    "locale": {
        "currency": 'EUR',
        "country": 'it-IT'
    },
    "logo": logo,
    "debug": true
}